import React from 'react';
type SpinnerProps = {
  size?: number;
  strokeWidth?: number;
  backgroundColor?: string;
};
const Spinner: React.SFC<SpinnerProps> = props => {
  const { size = 40, strokeWidth = 6, backgroundColor = 'bg-color--white' } = props;
  return (
    <span className={backgroundColor}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <polygon
          points={`0 0 0 ${size} ${size} ${size} ${size} 0`}
          className="movedash-rectangle"
          style={{
            strokeDasharray: size,
            stroke: 'white',
            backgroundColor: 'black',
            strokeWidth: `${strokeWidth}px`,
          }}
        />
      </svg>
    </span>
  );
};
export default Spinner;
